import React, { useEffect, useState } from "react";
import "../feeds/FeedDetail.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { handleCopy } from "../../../utils/copyClipboard";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { RiShareForwardLine } from "react-icons/ri";
import OverviewComment from "../Overview/section/OverviewComment";
import { avatar, dummyCard } from "../../../assets";
import { feedDetailApi, feedReactionApi } from "../../../services/feeds";
import { toastMessage } from "../../../utils/toastMessage";
import { FaArrowLeft, FaArrowRight, FaRegCommentDots } from "react-icons/fa";
import { getTimeDifference } from "../../../utils/dateTimeFormat";
import {
  SampleNextArrow,
  SamplePrevArrow,
} from "../../../components/slider/Arrow";
import CommentSection from "./comment/CommentSection";
import OverviewReport from "../Overview/section/OverviewReport";
import { reactions } from "../../../utils/staticData";
import { Dropdown } from "react-bootstrap";
import { HiDotsVertical } from "react-icons/hi";
import Slider from "react-slick";
import moment from "moment";
import { IoArrowBackOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import DeleteFeed from "../Overview/section/DeleteFeed";
import { feedDetailsLink } from "../../../utils/shareLink";
const FeedDetail = () => {
  const navigate = useNavigate();
  const { groupId, feedId } = useParams();
  const [feedDetail, setFeedDetail] = useState({});
  const [commentList, setCommentList] = useState([]);
  const [commentModal, setCommentModal] = useState(false);
  const [commentCount, setCommentCount] = useState("");
  const [reportModal, setReportModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const { showAuth } = useSelector((state) => state?.showAuth);
  console.log("feedDetail", feedDetail);
  // Setting For Corousel
  var settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: false,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,

    // dots: true,
    // infinite: true,
    // arrow: true,
    // speed: 500,
    // slidesToShow: 1,
    // slidesToScroll: 1,
    // nextArrow: <SampleNextArrow to="next" />,
    // prevArrow: <SamplePrevArrow to="prev" />,
  };
  // ---------navigate-Handler-group-details-----------
  const navigateHandler = (id) => {
    navigate(`/dashboard/group/detail/${id}`);
  };
  // ---------handle-report------------
  const handleReport = () => {
    setReportModal(true);
  };
  // ---------handle-Delete------------
  const handleDelete = (data) => {
    setDeleteModal(true);
  };
  // -----------feed-details-API-------------------
  const getFeedDetail = async () => {
    try {
      const { data } = await feedDetailApi({ _id: feedId });
      const { success, message, data: response } = data;

      if (success) {
        setFeedDetail(response);
      } else {
        toastMessage(message, "error", "getFeedDetail");
      }
    } catch (e) {
      console.error("Error:-", e.message);
    }
  };

  // Reaction On Feeds
  const handleFeedsReaction = async (reaction) => {
    try {
      const { data } = await feedReactionApi({ _feed: feedId, reaction });
      const { success, message } = data;
      if (success) {
        getFeedDetail();
      }
      toastMessage(
        message,
        success ? "success" : "error",
        "handleFeedsReaction"
      );
    } catch (e) {
      console.error(e.message);
    }
  };

  useEffect(() => {
    getFeedDetail();
  }, []);

  return (
    <>
      <DashboardHeader title={"Feed  Details"} />
      <div className="dashboard_pages">
        <div className="over_view_detail">
          <div className="breadcrumb_wrap">
            <ul>
              <li>
                <Link to={-1}>Home</Link>
              </li>
              <li>Post Details</li>
            </ul>
          </div>

          <div className="economy">
            <span>{feedDetail?._group?.name || "---"}</span>
          </div>

          <div className="detail_page over_view_detail_heading">
            <h5 className="detail_title">{feedDetail?.title || "---"}</h5>
            <div className="posted_by">
              <p>
                Posted by{" "}
                <b>
                  {feedDetail?._group?.settings?.anonymousPosting
                    ? "Anonymous"
                    : feedDetail?.createdBy?.fullName || "---"}
                </b>{" "}
                <span>{moment(feedDetail?.createdAt).fromNow()}</span>
              </p>{" "}
              <Dropdown className="custom_dropdown option_button has_border">
                <Dropdown.Toggle id="dropdown-basic">
                  <HiDotsVertical />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {feedDetail?.createdBy?._id === showAuth?._id ? (
                    <>
                      <Dropdown.Item
                        as={Link}
                        to={`/dashboard/feed/edit-feed/${feedDetail?._id}`}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(feedDetail)}>
                        Delete
                      </Dropdown.Item>
                    </>
                  ) : (
                    <Dropdown.Item onClick={() => handleReport(feedDetail)}>
                      Report
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="banner_image">
              <div className="upload_cover">
                <div className="slider_banner">
                  <Slider {...settings}>
                    {feedDetail?.attachments &&
                    feedDetail?.attachments?.length > 0 ? (
                      feedDetail?.attachments?.map((data, ind) => (
                        <div key={ind} className="upload_design_content">
                          {data.type === "VIDEO" ? (
                            <video
                              controls
                              width="100%"
                              poster={data.thumbnailUrl}
                            >
                              <source src={data.url} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          ) : (
                            <img src={data.url} alt="attachment" />
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="upload_design_content">
                        <img src={dummyCard} alt="attachment" />
                      </div>
                    )}
                  </Slider>
                </div>
              </div>
              {/* <img src={feedDetail?._group?.coverImage || avatar} /> */}
            </div>

            <div className="grp_name_contener">
              <div
                className="grp_name"
                onClick={() => navigateHandler(feedDetail?._group?._id)}
              >
                <img
                  src={feedDetail?.createdBy?.profilePicture || avatar}
                  alt=""
                />
                <p>
                  <span>Group name</span>
                  <b>{feedDetail?._group?.name}</b>
                </p>
              </div>
              <span>
                <FaArrowRight
                  onClick={() => navigateHandler(feedDetail?._group?._id)}
                />
              </span>
            </div>

            <div className="card_footer">
              <div className="action_icons_wraper">
                <div className="card_footer_like_share">
                  <button className="card_footer_btn">
                    {reactions?.map((data, ind) => (
                      <span key={ind}>
                        {feedDetail?.myReaction?.[data?.name]
                          ? data?.fillEmoji
                          : data?.emoji}
                      </span>
                    ))}
                  </button>

                  <div className="heart_icons">
                    <span>
                      {reactions?.map((data, ind) => (
                        <span
                          key={ind}
                          onClick={() => handleFeedsReaction(data?.name)}
                        >
                          {feedDetail?.myReaction?.[data?.name]
                            ? data?.fillEmoji
                            : data?.emoji}
                          {feedDetail?.reactions?.[data?.name] || ""}
                        </span>
                      ))}
                    </span>
                  </div>
                </div>

                <button
                  className="card_footer_btn_two"
                  onClick={() => setCommentModal(true)}
                >
                  {" "}
                  <FaRegCommentDots /> <span> {commentCount || ""} </span>{" "}
                  Comments
                </button>
              </div>

              <button
                onClick={() =>
                  handleCopy(
                    `${feedDetailsLink}${feedDetail?._group?._id}/${feedDetail?._id}`
                  )
                }
                className="card_footer_btn"
              >
                <RiShareForwardLine />
                <span>{feedDetail?.shareCount || ""}</span> Share
              </button>
            </div>

            <div className="traveling_text">
              {feedDetail?.description || "---"}
            </div>
          </div>
        </div>
      </div>

      {/* ---------comments--------------------- */}
      <OverviewComment
        show={commentModal}
        close={() => setCommentModal(false)}
        selectedData={feedDetail}
        setCommentCount={setCommentCount}
        pageName="Post"
      />
      {/* ---------report--------------------- */}
      <OverviewReport
        show={reportModal}
        close={() => setReportModal(false)}
        selectedData={feedDetail}
      />
      {/* //-----------feed-request----------------- */}
      {deleteModal && (
        <DeleteFeed
          show={deleteModal}
          close={() => setDeleteModal(false)}
          scroll={false}
          navigate={true}
          listing={getFeedDetail}
          id={feedDetail?._id}
          feedName={feedDetail?._group?.name}
          // setPage={setPage}
          // setHasMore={setHasMore}
        />
      )}
    </>
  );
};

export default FeedDetail;
